import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import Introduction from "../../components/Introduction";
import { useAuthContext } from "../../context/AuthContext";
import "./ClassesPage.css";
import Login from "../../components/Login";
import useFetchAuth from "../../hooks/useFetchAuth";
import config from "../../config";
import DefaultPage from "../DefaultPage/DefaultPage";
import Loader from "../../components/Loader";
import { getToken } from "../../helpers";
import { useNavigate } from "react-router-dom";

const ClassesPage = () => {
  const { user } = useAuthContext();
  const token = getToken();
  const navigate = useNavigate();
  // fetch dat - populate pro získání atributů z bloku kontaktu (contactDetail) a populate pro získání jmen z relace (contacts)
  const { data, loading, error } = useFetchAuth(
    `${config.api}/api/class-pages?populate=*`,
    token
  );

  // možné stavy při/po fetchi
  if (loading && token !== null) return <Loader />;
  if (error) return <DefaultPage message="Chyba při třídních stránek" />;

  const handleClick = (id) => {
    navigate(`/tridy/detail/${id}`);
  };

  // if (!data || !data.data)
  //   return <DefaultPage message="Chyba při třídních stránek" />;

  //? test na data z fetche
  //? console.log(data);
  //? console.log(user);
  //? console.log(token);
  //? console.log(dataIntroduction);

  //změna titulku stránky v prohlížeči
  document.title = "Třídy";

  return (
    <div className="min-height-100 d-flex flex-column container-fluid background-white">
      <Navbar />
      <Introduction title="Třídní stránky" text="" />
      <div className="container container-background p-4 p-md-5">
        {!user ? (
          <Login />
        ) : (
          <div>
            <h1 className="text-center">{user.username}</h1>
            <div className="class-page-container">
              {data.data.map((classPage) => (
                <div
                  key={classPage.documentId}
                  className="class-page"
                  style={{
                    backgroundImage: `linear-gradient(to top, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.7) 40%, rgba(255, 255, 255, 0.1) 60%), url(${config.api}${classPage.image?.url})`,
                    backgroundSize: "cover", // Ensures the image covers the div
                    backgroundPosition: "center", // Centers the image
                    backgroundRepeat: "no-repeat", // Prevents tiling if the image is smaller than the div
                  }}
                  onClick={() => {
                    handleClick(classPage.id);
                  }}
                >
                  <h3>{classPage.name}</h3>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};
export default ClassesPage;
